import { Component, EventEmitter, Injectable, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { DateRange, MAT_DATE_RANGE_SELECTION_STRATEGY, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, TimeRange } from '@library/store/measures/measures.interface';
import * as moment from 'moment-timezone';
import { pairwise, repeat, take } from 'rxjs';

@Injectable()
export class WeekRangeSelectionStrategy implements MatDateRangeSelectionStrategy<moment.Moment> {
  constructor(private _dateAdapter: DateAdapter<moment.Moment>) {}

  selectionFinished(date: moment.Moment | null): DateRange<moment.Moment> {
    return this._createWeekRange(date);
  }

  createPreview(activeDate: moment.Moment | null): DateRange<moment.Moment> {
    return this._createWeekRange(activeDate);
  }

  private _createWeekRange(date: moment.Moment | null): DateRange<moment.Moment> {
    if (date) {
      const start = date.clone().startOf('isoWeek');
      const end = date.clone().endOf('isoWeek');
      return new DateRange<moment.Moment>(start, end);
    }

    return new DateRange<moment.Moment>(null, null);
  }
}

@Component({
  selector: 'app-week-picker',
  templateUrl: './week-picker.component.html',
  styleUrls: ['./week-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: WeekRangeSelectionStrategy,
    },
  ]
})
export class WeekPickerComponent {

  dateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  maxDate = new Date();

  @Input() value: TimeRange;
  @Input() minDate = moment('2011');
  @Output() valueChange = new EventEmitter<TimeRange>();

  @Input() touchUi = false;

  ngOnInit() {
    this.dateRange.valueChanges.pipe(
      take(2),
      pairwise(),
      repeat(),
    ).subscribe(([, dateRange]: Partial<DateRange<moment.Moment>>[]) => {
      this.valueChange.next({
        dateBegin: startOfApiScale(dateRange.start.clone(), EnumApiScales.THREE_HOURS),
        dateEnd: endOfApiScale(dateRange.start.clone(), EnumApiScales.THREE_HOURS),
      });
    })

    this.dateRange.patchValue({
      start: this.value.dateBegin,
      end: this.value.dateEnd,
    }, {emitEvent: false})
  }

  ngOnChanges() {
    if (this.dateRange.value.start && this.dateRange.value.end) {
      if (!this.dateRange.value.start.isSame(this.value.dateBegin) || !this.dateRange.value.end.isSame(this.value.dateEnd)) {
        this.dateRange.patchValue({
          start: this.value.dateBegin,
          end: this.value.dateEnd,
        }, {emitEvent: false})
      }
    }
  }

}
